import { registerPlugin } from '@capacitor/core';

import type { rtsp_viewPlugin, rtsp_jniPlugin } from './definitions';

const rtsp_view = registerPlugin<rtsp_viewPlugin>('rtsp_view', {
  web: () => import('./web').then(m => new m.rtsp_viewWeb()),
});

/**
 * @deprecated 此插件已废弃，请使用rtsp_view插件，它现在包含了所有JNI功能
 */
const rtsp_jni = registerPlugin<rtsp_jniPlugin>('rtsp_jni', {
  web: () => import('./web').then(m => new m.rtsp_jniWeb()),
});

export * from './definitions';
export { rtsp_view, rtsp_jni };
